// extracted by mini-css-extract-plugin
export var alignBaseline = "_w-9";
export var alignCenter = "_w-5";
export var alignFlexEnd = "_w-7";
export var alignFlexStart = "_w-6";
export var alignSelfBaseline = "_w-e";
export var alignSelfCenter = "_w-a";
export var alignSelfFlexEnd = "_w-c";
export var alignSelfFlexStart = "_w-b";
export var alignSelfStretch = "_w-d";
export var alignStretch = "_w-8";
export var column = "_w-2";
export var columnReverse = "_w-4";
export var flex = "_w-0";
export var justifyCenter = "_w-f";
export var justifyFlexEnd = "_w-h";
export var justifyFlexStart = "_w-g";
export var justifySpaceAround = "_w-j";
export var justifySpaceBetween = "_w-i";
export var justifySpaceEvenly = "_w-k";
export var row = "_w-1";
export var rowReverse = "_w-3";
export var wrapNowrap = "_w-m";
export var wrapWrap = "_w-l";
export var wrapWrapReverse = "_w-n";